import { AccountService } from '@core/services/account/account.service';
import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { UntypedFormBuilder, Validators, UntypedFormGroup, AbstractControl } from '@angular/forms';
import { of } from 'rxjs';
import { delay, switchMapTo, map } from 'rxjs/operators';

@Component({
    selector: 'app-otp-form',
    templateUrl: './otp-form.component.html',
    styles: [],
    standalone: false
})
export class OtpFormComponent implements OnInit, AfterViewInit {
  @Input() invalidCode = false;
  @Input() isLogin = false;
  @Input() text?: string;
  @Input() resendText?: string;
  @Input() title?: string;
  @Output() send = new EventEmitter<string>();
  @Output() repeat = new EventEmitter<void>();
  @Output() hide = new EventEmitter<void>();
  @ViewChild('otpInput') otpInput: ElementRef<HTMLInputElement>;
  @Input() email?: boolean;
  phone$ = this.accountService.currentCustomer$.pipe(
    map((customer) => customer?.DatosPersonales?.telefonoMovil)
  );

  form: UntypedFormGroup;
  submitted = false;

  constructor(private formBuilder: UntypedFormBuilder, private accountService: AccountService) {}

  ngOnInit() {
    this.createForm();
  }

  ngAfterViewInit(): void {
    this.focusInput(100);
  }

  focusInput(delay = 0): void {
    setTimeout(() => {
      this.otpInput?.nativeElement?.focus();
    }, delay);
  }

  resetOtp(): void {
    this.submitted = false;
    this.form.reset();
    this.focusInput();
  }

  onSubmit() {
    this.submitted = true;
    this.form.markAllAsTouched();

    if (this.form.valid) {
      this.send.emit(String(this.form.get('secretKey').value));
    }
  }

  onRepeat() {
    this.submitted = false;
    this.form.get('secretKey').setValue('');
    this.form.get('secretKey').markAsUntouched();
    this.form.get('secretKey').markAsPristine();
    this.repeat.emit();
  }

  getMaskPhoneNumber(phone?: string | null) {
    const trimmed = phone?.substring(9) ?? null;
    return trimmed ? `*********${trimmed}` : '';
  }

  hasError(control: AbstractControl | null) {
    return !!control && this.submitted && control.invalid;
  }

  private createForm() {
    this.form = this.formBuilder.group({
      secretKey: ['', [Validators.required, Validators.maxLength(6), Validators.minLength(6)]],
    });
  }
}
